function composePermission(module: string, context: string, action: string): string {
  return `[${module}]${context}:${action}`;
}

export class PermissionCollection {
  //About page
  public static uploadImage = composePermission('Core', 'About', 'uploadImage');
  public static deleteImage = composePermission('Core', 'About', 'deleteImage');
  public static addHeadline = composePermission('Core', 'About', 'addHeadline');
  public static uploadLargerImage = composePermission('Core', 'About', 'uploadLargerImage');
  public static deleteLargerImage = composePermission('Core', 'About', 'deleteLargerImage');
  public static addDescription = composePermission('Core', 'About', 'addDescription');
  public static addWebsite = composePermission('Core', 'About', 'addWebsite');
  public static verifySupplier = composePermission('Core', 'About', 'verifySupplier');
  public static addProductionCapacity = composePermission('Core', 'About', 'addProductionCapacity');
  public static addTotalPipeline = composePermission('Core', 'About', 'addTotalPipeline');
  public static addKeyManLocation = composePermission('Core', 'About', 'addKeyManLocation');
  public static addGeoFocus = composePermission('Core', 'About', 'addGeoFocus');
  public static addDomains = composePermission('Core', 'About', 'addDomains');
  public static submitBidToPlatform = composePermission('Core', 'About', 'submitBidToPlatform');
  public static createCompanyProfile = composePermission('Core', 'About', 'createCompanyProfile');
  public static enableDisableCompanyProfile = composePermission('Core', 'About', 'enableDisableCompanyProfile');

  //Configuration page
  public static saveProjectConfiguration = composePermission(
    'Construction',
    'ConfigurationPage',
    'saveProjectConfiguration',
  );
  public static changeProjectEpc = composePermission('Construction', 'ConfigurationPage', 'changeProjectEpc');
  public static editDeleteDronOrtho = composePermission('Construction', 'Create', 'editDeleteDronOrtho');
  public static editDeleteDronePano = composePermission('Construction', 'Create', 'editDeleteDronePano');

  // Team members component
  public static editTeamMember = composePermission('Construction', 'TeamMemberTable', 'saveProjectConfiguration');

  public static shipmentListViewFlagAction = composePermission(
    'Construction',
    'Logistic',
    'shipmentListViewFlagAction',
  );
  public static deliveryVsMsaReport = composePermission('Construction', 'Logistic', 'deliveryVsMsaReport');
  public static deliveryVsEpcReport = composePermission('Construction', 'Logistic', 'deliveryVsEpcReport');
  public static deliveryVsMsaAndEpcReport = composePermission('Construction', 'Logistic', 'deliveryVsMsaAndEpcReport');
  public static progressTrackingReport = composePermission('Construction', 'Logistic', 'seeProgressTrackingReport');
  public static inventoryTrackingReport = composePermission('Construction', 'Logistic', 'seeProgressTrackingReport');
  public static addEditCommentsToLogisticsShipment = composePermission(
    'Construction',
    'Logistic',
    'addEditCommentsToLogisticsShipment',
  );

  //Projects
  public static canSeeRecenter = composePermission('Construction', 'Projects', 'canSeeRecenter');
  public static canEditProject = composePermission('Construction', 'Projects', 'canEditProject');
  public static navigateToProjectSetup = composePermission('Construction', 'Projects', 'navigateToProjectSetup');

  public static canAddEditRovers = composePermission('Construction', 'Projects', 'canAddEditRovers');
  public static canEditSchedule = composePermission('Construction', 'Projects', 'canEditSchedule');
  public static canAccessEditProject = composePermission('Construction', 'Projects', 'canAccessEditProject');
  public static canVerifyCircuitStatus = composePermission('Construction', 'Projects', 'canVerifyCircuitStatus');

  public static canAddNewConstructionProject = composePermission(
    'Construction',
    'Projects',
    'canAddNewConstructionProject',
  );
}
